// import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { NativeDateAdapter } from '@angular/material';
import { Platform } from '@angular/cdk/platform';
import * as dayjs from 'dayjs';
import 'dayjs/locale/vi';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
import * as localizedFormat from 'dayjs/plugin/localizedFormat';
import { DatePipe } from '@angular/common';

export class DateFormat extends NativeDateAdapter {
  constructor(matDateLocale: string, platform: Platform) {
    super(matDateLocale, platform);
    // Initalize DayJS-Parser
    dayjs.locale('vi');
    dayjs.extend(customParseFormat);
    dayjs.extend(localizedFormat);
  }
  parse(value: any): Date | null {

    let date = dayjs(value, 'D/M/YYYY');
    let day = Number(date.format("D"));
    let month = Number(date.format("M"));
    let year = Number(date.format("YYYY"));

    if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
      let str = value.split('/');
      const yearParsed = Number(str[2]);
      const monthParsed = Number(str[1]);
      const dayParsed = Number(str[0]);
      let valid = (day === dayParsed) && (month === monthParsed) && (year === yearParsed);

      if (!valid) {
        return this.invalid();
      }

    }

    return date.toDate();
  }
  format(date: Date, displayFormat: any): string {
    return new DatePipe(this.locale).transform(date, 'dd/MM/yyyy');
  }
}
